import React from "react";
import "./header.css";

function Header() {
  return (
    <header className="header">
      <h1>Etähallittava infotaulu</h1>
      <p>Helppo tapa hallita infotaulun sisältöä keskitetysti</p>
    </header>
  );
}

export default Header;
